import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 400 } }

  disconnect() {
    clearTimeout(this.timeout)
  }

  // Dipanggil saat user MENGETIK (Input text)
  // Menggunakan delay (debounce) agar tidak request setiap huruf
  submit(event) {
    if (this.isTomSelectSearchInput(event)) return

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.requestSubmitSafely()
    }, this.delayValue)
  }

  // Dipanggil saat user MEMILIH DROPDOWN (Select)
  // Tanpa delay (0ms), langsung refresh tabel
  submitImmediate(event) {
    if (event) event.stopPropagation()

    clearTimeout(this.timeout)
    this.requestSubmitSafely()
  }

  requestSubmitSafely() {
    if (!(this.element instanceof HTMLFormElement)) return
    if (!this.element.isConnected) return

    this.element.requestSubmit()
  }

  isTomSelectSearchInput(event) {
    if (!event || event.type !== "input") return false
    if (!(event.target instanceof HTMLElement)) return false

    return Boolean(event.target.closest(".ts-wrapper"))
  }
}
